export default __webpack_public_path__ + "locales/bg/ChangeUserTypeDialog.json?hash=86dac3fa11df43d3c307ae0678e74ac8";